export default "__VITE_ASSET__6fb6f03a__"